import { Capacitor } from '@capacitor/core';
import { Filesystem, Directory } from '@capacitor/filesystem';
import { FileOpener } from '@capacitor-community/file-opener';

/**
 * Save a base64-encoded file on both web and Capacitor native (Android/iOS).
 * On native, writes to the Documents folder and opens the file immediately.
 *
 * @param {string} base64Data  Raw base64 string (no data-URI prefix)
 * @param {string} mimeType    e.g. 'application/pdf', 'image/jpeg', 'image/png'
 * @param {string} fileName    e.g. 'certificate.pdf'
 */
export const saveFile = async (base64Data, mimeType, fileName) => {
  if (Capacitor.isNativePlatform()) {
    const result = await Filesystem.writeFile({
      path: fileName,
      data: base64Data,
      directory: Directory.Documents,
      recursive: true,
    });
    try {
      await FileOpener.open({ filePath: result.uri, contentType: mimeType });
    } catch (_) {
      alert(`File saved:\n${fileName}\n\nOpen it from your Files app.`);
    }
  } else {
    const byteChars = atob(base64Data);
    const byteArr = new Uint8Array(byteChars.length);
    for (let i = 0; i < byteChars.length; i++) byteArr[i] = byteChars.charCodeAt(i);
    const blob = new Blob([byteArr], { type: mimeType });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    a.click();
    URL.revokeObjectURL(url);
  }
};
